import * as React from "react";
import { Check, Minus } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const comparisonData = [{
  feature: "Emisiones de CO₂",
  traditional: "100% (Línea base)",
  aiux: "Reducción del 80%"
}, {
  feature: "Lubricidad del Motor",
  traditional: "Estándar",
  aiux: "Protección Superior"
}, {
  feature: "Biodegradabilidad",
  traditional: "No biodegradable",
  aiux: "Totalmente biodegradable"
}, {
  feature: "Fuente de Energía",
  traditional: "Combustibles fósiles",
  aiux: "Biomasa reciclada"
}, {
  feature: "Impacto Local",
  traditional: "Dependiente de importaciones",
  aiux: "Soberanía cubana"
}];
export default function TheGreenAdvantage() {
  return <section data-section-id="262926" id="the-green-advantage" className="dark bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-primary/20 blur-[120px] rounded-lg pointer-events-none" />
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
            Ventaja <span className="bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">Verde</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Compare el rendimiento ambiental y mecánico del biodiésel BioPower frente al diésel de petróleo tradicional.
          </p>
        </div>

        <div className="rounded-xl border-border/20 bg-card/30 backdrop-blur overflow-hidden shadow-xl">
          <Table>
            <TableHeader>
              <TableRow className="border-b border-border/50 hover:bg-transparent">
                <TableHead className="w-[30%] text-muted-foreground font-medium py-6 pl-6 font-default">
                  Métrica de Rendimiento
                </TableHead>
                <TableHead className="w-[35%] text-center text-muted-foreground font-medium py-6 font-default">
                  Diésel de Petróleo
                </TableHead>
                <TableHead className="w-[35%] text-center text-primary font-bold text-lg py-6 bg-primary/10 border-x border-primary/20 font-default">
                  BioPower
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisonData.map((row, i) => <TableRow key={i} data-index={i} className="border-b border-border/50 hover:bg-muted/10 transition-colors">
                  <TableCell className="font-medium py-5 md:py-6 pl-6 text-foreground/90 font-default">
                    {row.feature}
                  </TableCell>
                  <TableCell className="text-center py-5 md:py-6 text-muted-foreground font-default">
                    <div className="flex items-center justify-center gap-2">
                      <Minus className="size-5 opacity-50 drop-shadow-[0_0_8px_rgba(255,255,255,0.2)]" />
                      <span>{row.traditional}</span>
                    </div>
                  </TableCell>
                  <TableCell className="text-center py-5 md:py-6 font-semibold text-foreground bg-primary/5 border-x border-primary/10 relative font-default">
                    {}
                    <div className="absolute inset-y-0 left-0 w-[1px] bg-gradient-to-b from-transparent via-primary/40 to-transparent" />
                    <div className="absolute inset-y-0 right-0 w-[1px] bg-gradient-to-b from-transparent via-primary/40 to-transparent" />
                    
                    <div className="flex items-center justify-center gap-2 relative z-10">
                      <Check className="size-5 text-primary drop-shadow-[0_0_10px_rgba(34,197,94,0.5)]" />
                      <span className="tracking-wide">{row.aiux}</span>
                    </div>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}